import { render, staticRenderFns } from "./WorkItemForm.vue?vue&type=template&id=29f6f5f0&scoped=true"
import script from "./WorkItemForm.vue?vue&type=script&lang=js"
export * from "./WorkItemForm.vue?vue&type=script&lang=js"
import style0 from "./WorkItemForm.vue?vue&type=style&index=0&id=29f6f5f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f6f5f0",
  null
  
)

export default component.exports